import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'maskCard'
})
export class MaskCardPipe implements PipeTransform {

    transform(value: string | number): string {
        if (!value) return '';
        const str = value.toString().replace(/\s+/g, ''); // elimina espacios previos
        return str.replace(/(.{4})/g, '$1 ').trim(); // agrega espacio cada 4
    }

}
